import UrlMatchRule from './UrlMatchRule'
import UserPropertyRule from './UserPropertyRule'

export default class RuleChecker {
	constructor (user) {
		this.user = user

		this.checkers = {
			'url_match': new UrlMatchRule(),
			'user_property': new UserPropertyRule(this.user)
		}
	}

	check (rules) {
		if (!rules || rules.length <= 0) {
			return true
		}

		let rulesGrouped = this._groupRulesByOperator(rules)

		for (let index in rulesGrouped) {
			let result = this._checkRulesGroup(rulesGrouped[index])

			if (result === true) {
				return true
			}
		}

		return false
	}

	_groupRulesByOperator (rules) {
		let grouped = {}
		let groupIndex = 0

		for (let index in rules) {
			let currentRule = rules[index]

			if (currentRule.operator_name === 'or') {
				groupIndex++
			}

			if (typeof grouped[groupIndex] === 'undefined') {
				grouped[groupIndex] = []
			}

			grouped[groupIndex].push(currentRule)
		}

		return grouped
	}

	_checkRulesGroup (rulesGrouped) {
		for (let index in rulesGrouped) {
			let rule = rulesGrouped[index]

			if (!(rule.type in this.checkers)) {
				return false
			}

			let result = this.checkers[rule.type].checkRule(rule)

			if (result === false) {
				return false
			}
		}

		return true
	}
}



// WEBPACK FOOTER //
// ./src/common/components/Onboarding/RuleChecker/RuleChecker.js